import { render, staticRenderFns } from "./activedUser.vue?vue&type=template&id=31e4b80b&scoped=true&"
import script from "./activedUser.vue?vue&type=script&lang=js&"
export * from "./activedUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e4b80b",
  null
  
)

export default component.exports